"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.letterSigningSource = letterSigningSource;
const SigningApi_1 = require("../../Signing/SigningApi");
const letterSignaturesStore_1 = require("./letterSignaturesStore");
/** Pismo (kontraktowe albo ofertowe) jako źródło plików do podpisu. */
function letterSigningSource(letterId, letterNumber) {
    return {
        key: `letter-${letterId}`,
        listFiles: () => SigningApi_1.SigningApi.listSignableFiles(letterId),
        createJob: (files) => SigningApi_1.SigningApi.createJob(letterId, files),
        listSignatures: async () => (await SigningApi_1.SigningApi.listLetterSignatures(letterId)).signatures,
        uploadSigned: (file) => SigningApi_1.SigningApi.uploadSigned(letterId, file),
        onChanged: () => (0, letterSignaturesStore_1.invalidateLetterSignatures)(letterId),
        texts: {
            subject: `pismo ${letterNumber ?? ""}`.trim(),
            inFolder: "w folderze pisma",
            thisHasAlready: "To pismo ma już",
            mainDocBadge: "pismo",
            lockedGraphicNote: "Pismo zawsze dostaje widoczny podpis z grafiką ENVI (pod „Z poważaniem”), więc tego pola nie da się wyłączyć.",
            noMainDocNote: "Pismo nie ma dokumentu na Dysku — nie ma czego podpisać.",
            doneNote: "Na liście pism pismo ma teraz plakietkę „podpisane”.",
        },
    };
}
